import env from '@beam-australia/react-env';
import React from 'react';
import { usePlacesWidget } from 'react-google-autocomplete';
import TextField from '@mui/material/TextField';
import PropTypes from 'prop-types';
import { camelCaseKeys } from '@/utils/transformKeys';

/**
 * A text input field that hooks into the Google Places API for autcomplete
 * functionality. It takes all the same props as the TextField input in MUI,
 * but of not the onChange event only fires when an place is selected, and it
 * responds with two arguments, the first being the formatted name of the
 * address, and the second being a more comprehensive place object.
 */
function AddressAutocomplete({ inputAutocompleteValue, onChange, ...rest }) {
  const { ref } = usePlacesWidget({
    apiKey: env('GOOGLE_GEO_KEY'),
    onPlaceSelected: (googlePlace) => {
      const place = camelCaseKeys(googlePlace);
      onChange(place.formattedAddress, place);
    },
    inputAutocompleteValue,
    options: {
      fields: [
        // TODO(jon): Need to confirm what all place components we need.
        'address_components',
        'formatted_address',
        'geometry',
        'place_id',
      ],
      types: ['address'],
    },
  });
  return (
    <TextField
      fullWidth
      {...rest}
      inputRef={ref}
      inputProps={{
        onKeyDown: (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
          }
        },
      }}
    />
  );
}

AddressAutocomplete.propTypes = {
  inputAutocompleteValue: PropTypes.string,
  onChange: PropTypes.func,
};

AddressAutocomplete.defaultProps = {
  inputAutocompleteValue: 'formatted_address',
  onChange: () => {},
};

export default AddressAutocomplete;
